import { gql } from "@apollo/client";

export const UPDATE_PARCEL = gql`
mutation UpdateRoomVersion($id: uuid!, $version: String!) {
  update_rooms(
    where: { id: { _eq: $id } }
    _set: { version: $version }
  ) {
    affected_rows
    returning {
      id
      version
    }
  }
}
`